import { useQuery } from "@tanstack/react-query";

import { fetchAddressesRequest } from "./fetch-addresses.request";

export const FETCH_ADDRESSES_QUERY_KEY = "fetch-addresses";

export const useFetchAddressesQuery = (query: string, enabled: boolean) =>
  useQuery({
    queryKey: [FETCH_ADDRESSES_QUERY_KEY, query],
    queryFn: async () => fetchAddressesRequest(query),
    enabled,
  });
